import { makeApiCall, makeApiCallWithFile } from "./makeApiCall";
import { Url } from "./constantUrl";
import {
    NOTIFICATION_LIST_REQUEST,
    NOTIFICATION_LIST_SUCCESS,
    NOTIFICATION_LIST_FAIL,
    CREATE_SCHEDULE_NOTIFICATION_REQUEST,
    CREATE_SCHEDULE_NOTIFICATION_SUCCESS,
    CREATE_SCHEDULE_NOTIFICATION_FAILURE,
    CREATE_BULK_SCHEDULE_NOTIFICATION_REQUEST,
    CREATE_BULK_SCHEDULE_NOTIFICATION_SUCCESS,
    CREATE_BULK_SCHEDULE_NOTIFICATION_FAILURE,
    NOTIFICATION_DETAILS_REQUEST,
    NOTIFICATION_DETAILS_SUCCESS,
    NOTIFICATION_DETAILS_FAIL,
    USER_GROUP_REQUEST,
    USER_GROUP_SUCCESS,
    USER_GROUP_FAIL,
    REDIRECTION_PAGE_REQUEST,
    REDIRECTION_PAGE_SUCCESS,
    REDIRECTION_PAGE_FAIL,
    UPDATE_SCHEDULE_NOTIFICATION_REQUEST,
    UPDATE_SCHEDULE_NOTIFICATION_SUCCESS,
    UPDATE_SCHEDULE_NOTIFICATION_FAILURE,
    BULK_NOTIFICATION_DETAILS_REQUEST,
    BULK_NOTIFICATION_DETAILS_SUCCESS,
    BULK_NOTIFICATION_DETAILS_FAIL,UPDATE_BULK_SCHEDULE_NOTIFICATION_REQUEST,
    UPDATE_BULK_SCHEDULE_NOTIFICATION_SUCCESS,
    UPDATE_BULK_SCHEDULE_NOTIFICATION_FAILURE
} from "./types";

export const getNotificationListAction = (page = '1', pageSize, filters = {}) => async (dispatch) => {
    return makeApiCall({
        method: 'GET',
        endpoint: Url.GET_NOTIFICATION_SCHEDULE_LIST,
        dispatch,
        requestType: NOTIFICATION_LIST_REQUEST,
        successType: NOTIFICATION_LIST_SUCCESS,
        failureType: NOTIFICATION_LIST_FAIL,
        params: {
            page,
            page_size: pageSize,
            ...filters
        },
    });
}

export const createNotificationScheduleAction = (formData) => async (dispatch) => {
    return makeApiCall({
        method: 'POST',
        endpoint: Url.CREATE_NOTIFICATION_SCHEDULE,
        data: formData,
        dispatch,
        requestType: CREATE_SCHEDULE_NOTIFICATION_REQUEST,
        successType: CREATE_SCHEDULE_NOTIFICATION_SUCCESS,
        failureType: CREATE_SCHEDULE_NOTIFICATION_FAILURE,
    });
};

export const createNotificationScheduleBulkAction = (formData) => async (dispatch) => {
    return makeApiCallWithFile({
        method: 'POST',
        endpoint: Url.CREATE_NOTIFICATION_SCHEDULE,
        data: formData,
        dispatch,
        requestType: CREATE_BULK_SCHEDULE_NOTIFICATION_REQUEST,
        successType: CREATE_BULK_SCHEDULE_NOTIFICATION_SUCCESS,
        failureType: CREATE_BULK_SCHEDULE_NOTIFICATION_FAILURE,
    });
};

export const getNotificationDetailsAction = (id) => async (dispatch) => {
    return makeApiCall({
        method: 'GET',
        endpoint: Url.GET_DETAIL_SCHEDULE_NOTIFICATION + `?id=${id}`,
        dispatch,
        requestType: NOTIFICATION_DETAILS_REQUEST,
        successType: NOTIFICATION_DETAILS_SUCCESS,
        failureType: NOTIFICATION_DETAILS_FAIL,
    });
}

export const getBulkNotificationDetailsAction = (id) => async (dispatch) => {
    return makeApiCall({
        method: 'GET',
        endpoint: Url.GET_DETAIL_SCHEDULE_NOTIFICATION + `?id=${id}`,
        dispatch,
        requestType: BULK_NOTIFICATION_DETAILS_REQUEST,
        successType: BULK_NOTIFICATION_DETAILS_SUCCESS,
        failureType: BULK_NOTIFICATION_DETAILS_FAIL,
    });
}

export const updateNotificationAction = (userId, payload) => async (dispatch) => {
    const endpoint = `${Url.UPDATE_SCHEDULE_NOTIFICATION}/${userId}`;

    return makeApiCall({
        method: 'PUT',
        endpoint,
        data: payload,
        dispatch,
        requestType: UPDATE_SCHEDULE_NOTIFICATION_REQUEST,
        successType: UPDATE_SCHEDULE_NOTIFICATION_SUCCESS,
        failureType: UPDATE_SCHEDULE_NOTIFICATION_FAILURE,
    });
};

export const updateBulkNotificationAction = (userId, payload) => async (dispatch) => {
    const endpoint = `${Url.UPDATE_SCHEDULE_NOTIFICATION}/${userId}`;
    return makeApiCallWithFile({
        method: 'PUT',
        endpoint,
        data: payload,
        dispatch,
        requestType: UPDATE_BULK_SCHEDULE_NOTIFICATION_REQUEST,
        successType: UPDATE_BULK_SCHEDULE_NOTIFICATION_SUCCESS,
        failureType: UPDATE_BULK_SCHEDULE_NOTIFICATION_FAILURE,
    });
};

export const getUserGroupAction = () => async (dispatch) => {
    return makeApiCall({
        method: 'GET',
        endpoint: Url.GET_USER_GROUP,
        dispatch,
        requestType: USER_GROUP_REQUEST,
        successType: USER_GROUP_SUCCESS,
        failureType: USER_GROUP_FAIL,
    })
}

export const getRedirectionPageAction = () => async (dispatch) => {
    return makeApiCall({
        method: 'GET',
        endpoint: Url.GET_REDIRECTION_PAGE,
        dispatch,
        requestType: REDIRECTION_PAGE_REQUEST,
        successType: REDIRECTION_PAGE_SUCCESS,
        failureType: REDIRECTION_PAGE_FAIL,
    })
}